module.exports = __webpack_public_path__ + "static/media/icon-start-date.20d9da54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-start-date.svg
// module id = ./src/assets/images/icon-start-date.svg
// module chunks = 0